<div class="row mt-3">
  <div class="col-auto">
    <a href="https://alfa.me/iPB2Pt" target="_blank" rel="noopener noreferrer">
      <img
        class="w-100 custom-rounded"
        src="assets/landingFiles/images/banner.png"
        alt="Осаго Альфабанк онлайн"
        loading="lazy">
    </a>
  </div>
</div>
